import React, { useEffect, useState } from 'react';

function HoverVideo({ imgSrc, videosrc, link, title, subTitle }) {
  const [isHovered, setIsHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => setIsMobile(window.innerWidth <= 768);
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  return (
    <div
      className="col-lg-4 col-md-6 mb-30"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <a href={link} target="_blank" rel="noopener noreferrer">
        <div className="img o-hidden radius-15 fit-img relative overflow-hidden">
          {isHovered || isMobile ? (                                                 
            <video
              src={videosrc}
              autoPlay
              loop
              muted
              playsInline
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          ) : (
            <img
              src={imgSrc}
              alt={title}
              className="w-100 h-100 object-cover radius-15"
            />
          )}
        </div>
        {/* Title & Subtitle */}
        <div className="cont d-md-flex align-items-center mt-30 pb-15 gap-3">
          <div>
            <h5 className="fw-600">{title}</h5>
            <div className='d-flex align-items-center gap-3'>
              <p className="fs-14 opacity-70">{subTitle}</p>
              <img
                src="/light/assets/imgs/arrow-right.webp"
                alt="arrow-right"
                className="icon-img-20 inline-block"
              />
            </div>
          </div>
          {/* Arrow Right Icon */}
        </div>
      </a>
    </div>
  );
}

function Services() {
  return (
    <section className="services-details pt-40 pb-40">
      <div className="container">
        <div className="row serv-imgs">
        <HoverVideo
            imgSrc="/light/assets/imgs/bjp-logo.jpeg"
            videosrc="/light/assets/imgs/rupesh-sawarkar.mp4"
            link="https://rupeshsawarkar.in/"  
            title="Rupesh Sawarkar"
            subTitle="Indian Political Website"
          />
          <HoverVideo
            imgSrc="/light/assets/imgs/swa-industries.jpeg"
            videosrc="/light/assets/imgs/swa-industries.mp4"
            link="https://swaindustries.in/"  
            title="SWA Industries"
            subTitle="Import Export Solution Company"
          />
        <HoverVideo
            imgSrc="/light/assets/imgs/vachan-enterprise-logo-1.webp"
            videosrc="/light/assets/imgs/vachanenterprises.mp4"
            link="https://vachanenterprises.com/"  
            title="Vachan Enterprises"
            subTitle="Chemical Trading Company"
          />
        <HoverVideo
            imgSrc="/light/assets/imgs/yogainsightpod.webp"
            videosrc="/light/assets/imgs/yoginsightpod.mp4"
            link="https://www.yogainsightpod.com/"
            title="Yoga Insight Pod"
            subTitle="Yoga Podcast Platform"
          />
        <HoverVideo
            imgSrc="/light/assets/imgs/calmsippco.webp"
            videosrc="/light/assets/imgs/calmsippco.mp4"
            link="https://calmsippco.com/"
            title="Calm Sippco"
            subTitle="Herbal Tea website"
          />
          {/* <HoverVideo
            imgSrc="/light/assets/imgs/arus-logo.webp"
            videosrc="/light/assets/imgs/arus-homemaker.mp4"
            link="https://arushomemaker.com/"
            title="Arus Homemaker"
            subTitle="Handmade Snacks & Foods"
          /> */}
          {/* <HoverVideo
            imgSrc="/light/assets/imgs/21.webp"
            videosrc="/light/assets/imgs/languagescube.mp4"
            link="https://languagescube.com/"
            title="Languages Cube"
            subTitle="Language Learning Platform"
          /> */}
          {/* <a href="https://languagescube.com/" target="_blank" rel="noopener noreferrer">
              <div className="img o-hidden radius-15 fit-img md-mb30">
                <img src="/light/assets/imgs/21.webp" alt="" />
              </div>
            </a> */}
          <HoverVideo
            imgSrc="/light/assets/imgs/1.webp"
            videosrc="/light/assets/imgs/designsbyprachi.mp4"
            link="https://designsbyprachi.com/"
            title="Designs by Prachi"
            subTitle="Interior Designer Portfolio"
          />
          {/* <a href="https://designsbyprachi.com/" target="_blank" rel="noopener noreferrer">
              <div className="img o-hidden radius-15 fit-img md-mb30">
                <img src="/light/assets/imgs/1.webp" alt="" />
              </div>
            </a> */}
          <HoverVideo
            imgSrc="/light/assets/imgs/2.webp"
            videosrc="/light/assets/imgs/farmhands.mp4"
            link="https://thefarmhandscollective.com/"
            title="Farmhands Collective"
            subTitle="Skin Care Products Website"
          />
          {/* <a href="https://thefarmhandscollective.com/" target="_blank" rel="noopener noreferrer">
              <div className="img o-hidden radius-15 fit-img md-mb30">
                <img src="/light/assets/imgs/2.webp" alt="" />
              </div>
            </a> */}
          <HoverVideo
            imgSrc="/light/assets/imgs/mamta_logo.webp"
            videosrc="/light/assets/imgs/mamtasupplychain.mp4"
            link="https://mamtasupplychain.com/"
            title="Mamta Supply Chain"
            subTitle="Logistics & Supply Chain"
          />
          {/* <a href="https://mamtasupplychain.com/" target="_blank" rel="noopener noreferrer">
              <div className="img o-hidden radius-15 fit-img md-mb30">
                <img src="/light/assets/imgs/mamta_logo.webp" alt="" />
              </div>
            </a> */}
          <HoverVideo
            imgSrc="/light/assets/imgs/mettico.webp"
            videosrc="/light/assets/imgs/mittieco.mp4"
            link="https://mittiecotech.com/"
            title="Mittieco Tech"
            subTitle="Farming IOT Solutions"
          />
          {/* <a href="https://mittiecotech.com/" target="_blank" rel="noopener noreferrer">
              <div className="img o-hidden radius-15 fit-img md-mb30">
                <img src="/light/assets/imgs/mettico.webp" alt="" />
              </div>
            </a> */}

          {/* <a href="https://thecyberhorizon.com/" target="_blank" rel="noopener noreferrer">
                <div className="img o-hidden radius-15 fit-img md-mb30">
                <img src="/light/assets/imgs/3.webp" alt="" />
                </div>
              </a> */}
          <HoverVideo
            imgSrc="/light/assets/imgs/AI-Agent-Bros.webp"
            videosrc="/light/assets/imgs/AI-Agent-bros.mp4"
            link="https://aiagentbros.com/"
            title="AI Agent Bros"
            subTitle="AI based Company"
          />
        </div>
        <div className="row mt-80">
          <div className="col-lg-4">
            <div className="text md-mb50">
              <p>
                Our team creates responsive, user-friendly websites optimized for performance and security, ensuring an engaging experience for your visitors. From design to deployment, we partner with you to bring your vision to life.
              </p>
            </div>
          </div>
          <div className="col-lg-8">
            <div className="row">
              <div className="col-md-6">
                <ul className="rest list-arrow">
                  <li className="nowrap">
                    <span className="icon">
                      <svg
                        width="100%"
                        height="100%"
                        viewBox="0 0 9 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M7.71108 3.78684L8.22361 4.29813L7.71263 4.80992L4.64672 7.87832L4.13433 7.36688L6.87531 4.62335H1.11181H0.750039H0.388177L0.382812 0.718232H1.10645L1.11082 3.90005H6.80113L4.12591 1.22972L4.63689 0.718262L7.71108 3.78684Z"
                          fill="#14cf93"
                        ></path>
                      </svg>
                    </span>
                    <h6 className="inline fw-400">Custom Website Development</h6>
                  </li>
                  <li className="mt-10 nowrap">
                    <span className="icon">
                      <svg
                        width="100%"
                        height="100%"
                        viewBox="0 0 9 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M7.71108 3.78684L8.22361 4.29813L7.71263 4.80992L4.64672 7.87832L4.13433 7.36688L6.87531 4.62335H1.11181H0.750039H0.388177L0.382812 0.718232H1.10645L1.11082 3.90005H6.80113L4.12591 1.22972L4.63689 0.718262L7.71108 3.78684Z"
                          fill="#14cf93"
                        ></path>
                      </svg>
                    </span>
                    <h6 className="inline fw-400">
                      Responsive Design
                    </h6>
                  </li>
                  <li className="mt-10 nowrap">
                    <span className="icon">
                      <svg
                        width="100%"
                        height="100%"
                        viewBox="0 0 9 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M7.71108 3.78684L8.22361 4.29813L7.71263 4.80992L4.64672 7.87832L4.13433 7.36688L6.87531 4.62335H1.11181H0.750039H0.388177L0.382812 0.718232H1.10645L1.11082 3.90005H6.80113L4.12591 1.22972L4.63689 0.718262L7.71108 3.78684Z"
                          fill="#14cf93"
                        ></path>
                      </svg>
                    </span>
                    <h6 className="inline fw-400">SEO Optimization.</h6>
                  </li>
                </ul>
              </div>
              <div className="col-md-6">
                <ul className="rest list-arrow">
                  <li className="nowrap">
                    <span className="icon">
                      <svg
                        width="100%"
                        height="100%"
                        viewBox="0 0 9 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M7.71108 3.78684L8.22361 4.29813L7.71263 4.80992L4.64672 7.87832L4.13433 7.36688L6.87531 4.62335H1.11181H0.750039H0.388177L0.382812 0.718232H1.10645L1.11082 3.90005H6.80113L4.12591 1.22972L4.63689 0.718262L7.71108 3.78684Z"
                          fill="#14cf93"
                        ></path>
                      </svg>
                    </span>
                    <h6 className="inline fw-400">E-commerce Solutions.</h6>
                  </li>
                  <li className="mt-10 nowrap">
                    <span className="icon">
                      <svg
                        width="100%"
                        height="100%"
                        viewBox="0 0 9 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M7.71108 3.78684L8.22361 4.29813L7.71263 4.80992L4.64672 7.87832L4.13433 7.36688L6.87531 4.62335H1.11181H0.750039H0.388177L0.382812 0.718232H1.10645L1.11082 3.90005H6.80113L4.12591 1.22972L4.63689 0.718262L7.71108 3.78684Z"
                          fill="#14cf93"
                        ></path>
                      </svg>
                    </span>
                    <h6 className="inline fw-400">
                      Content Management Systems (CMS).
                    </h6>
                  </li>
                  <li className="mt-10 nowrap">
                    <span className="icon">
                      <svg
                        width="100%"
                        height="100%"
                        viewBox="0 0 9 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M7.71108 3.78684L8.22361 4.29813L7.71263 4.80992L4.64672 7.87832L4.13433 7.36688L6.87531 4.62335H1.11181H0.750039H0.388177L0.382812 0.718232H1.10645L1.11082 3.90005H6.80113L4.12591 1.22972L4.63689 0.718262L7.71108 3.78684Z"
                          fill="#14cf93"
                        ></path>
                      </svg>
                    </span>
                    <h6 className="inline fw-400">Ongoing Support & Maintenance.</h6>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
